import { Component, Inject, OnInit, EventEmitter, Output, ViewEncapsulation } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { FormGroup, FormBuilder } from '@angular/forms';
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { SaveService } from '../../../services/save.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatChipInputEvent } from "@angular/material/chips";

@Component({
    selector: "contacttounit-filter",
    templateUrl: './contacttounit-filter.component.html',
    styleUrls: ['../../../style/form.component.less', './contacttounit-filter.component.less', '../../../style/expand-collapse-panel.component.less'],
    standalone: false,
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ],
    encapsulation: ViewEncapsulation.None
})

export class ContactToUnitFilterComponent implements OnInit {

    form!: FormGroup;
    @Output() outputFilter = new EventEmitter<ContactToUnitFilter>();

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [COMMA, TAB, ENTER];

    unitIds: string[] = [];
    contractNumbers: string[] = [];
    customerIds: string[] = [];
    contactIds: string[] = [];
    onlyActiveContracts: boolean = false;

    constructor(
        private http: HttpClient
        , private fb: FormBuilder
        , @Inject('BASE_URL') private baseUrl: string
        , private saveService: SaveService
    ) {
    }

    ngOnInit() {
        this.saveService.addListener(this);
        this.createForm();
    }

    createForm() {
        this.form = this.fb.group({
        });
    }

    changeTypeButton() {
        return this.unitIds.length < 1 && this.customerIds.length < 1
            && this.contractNumbers.length < 1 && this.contactIds.length < 1
    }

    applyFilter(event: MatChipInputEvent, list: string): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            switch (list) {
                case 'unitids':
                    this.unitIds.push(value.replace('+', '').trim()); break;
                case 'contractnumbers':
                    this.contractNumbers.push(value.replace('+', '').trim()); break;
                case 'customerids':
                    this.customerIds.push(value.replace('+', '').trim()); break;
                case 'contactids':
                    this.contactIds.push(value.replace('+', '').trim()); break;
            }
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    remove(item: string, list: string): void {
        let index = -1
        switch (list) {
            case 'unitids':
                index = this.unitIds.indexOf(item);
                if (index >= 0)
                    this.unitIds.splice(index, 1);
                break;
            case 'contractnumbers':
                index = this.contractNumbers.indexOf(item);
                if (index >= 0)
                    this.contractNumbers.splice(index, 1);
                break;
            case 'customerids':
                index = this.customerIds.indexOf(item);
                if (index >= 0)
                    this.customerIds.splice(index, 1);
                break;
            case 'contactids':
                index = this.contactIds.indexOf(item);
                if (index >= 0)
                    this.contactIds.splice(index, 1);
                break;
        }
    }

    onFilter() {
        const filter: ContactToUnitFilter = {
            'UnitIds': this.unitIds,
            'ContractNumbers': this.contractNumbers,
            'CustomerIds': this.customerIds,
            'ContactIds': this.contactIds,
            'OnlyActiveContracts': this.onlyActiveContracts
        }
        this.outputFilter.emit(filter);
    }
}